// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ALL_DATES = "V\u0161etky term\u00edny";
export const FIND_A_BRIDE_BY_NAME_OR_LOGIN = "Zadaj login";
export const ORDER_BY = "Zora\u010f pod\u013ea";
export const ORDER_BY_DATE_JOINED = "d\u00e1tumu registr\u00e1cie";
export const ORDER_BY_LAST_LOGIN = "d\u00e1tumu prihl\u00e1senia";
export const ORDER_BY_USERNAME = "loginu";
export const USERS_DIRECTORY_COUNTRY = "Bydlisko - krajina";
export const USERS_DIRECTORY_COUNTY = "Okres";
export const USERS_DIRECTORY_DUE_DATE = "Term\u00edn";
export const USERS_DIRECTORY_SEARCH = "H\u013eadaj";
